<template>
  <el-dialog
    :visible="dialogVisible"
    width="900px"
    height="482px"
    custom-class="materialListWrap"
    :append-to-body="true"
  >
    <el-tabs v-model="activeName" v-if="dialogVisible">
      <el-tab-pane :label="$tt('我的素材')" name="my">
        <div>
          <el-button
              type="primary"
              size="mini"
              style="margin-right: 10px"
              icon="el-icon-refresh"
              @click="getMaterialsData(1,8)"
          >{{ $tt("刷新") }}</el-button>
        </div>
        <!-- 添加图片列表容器 -->
        <div class="image-list-container">
          <div class="list">
            <div
                v-for="o in materialListDataInfo.result"
                :class="['one', selectedM.id == o.id && 'selected']"
                :key="o.id"
                @click="selectedM = o"
            >
              <div class="top">
                <img :src="o.file_down_path" class="image" />
              </div>
              <div class="bottom" :title="o.file_real_name">
                {{ o.file_real_name }}
              </div>
              <i class="el-icon-success selectedIcon" v-if="selectedM.id == o.id"></i>
            </div>
            <Pagination
                ref="pagination"
                v-if="materialListDataInfo.total > 7"
                :handleSizeChange="handleSizeChange"
                :handleCurrentPageChange="handleCurrentPageChange"
                :pageNum="pageNum"
                :total="materialListDataInfo.total"
            />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$tt('公共素材')" name="common">
        <div class="common-material-container">
          <CommonMaterial :selectedM="selectedM" v-if="activeName === 'common'" :isDialog="true" @selected="commonSelected"></CommonMaterial>
        </div>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button @click="quickEntrance">{{ $tt("快捷入口") }}</el-button>
      <el-button @click="onClose">{{ $tt("取 消") }}</el-button>
      <el-button type="primary" @click="confirmToChange">{{ $tt("确 定") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import CommonMaterial from './CommonMaterial';
import { mapState, mapActions } from "vuex";
import { getCurComponentsInd } from '@/utils/utils';
import { setMusicControlIcon } from "@/utils/musicExt";
export default {
  props: {
    modalOperationKey: String,
    setCarouselPics: Function,
    confirm: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Pagination,
    CommonMaterial
  },
  data() {
    return {
      dialogVisible: false,
      materialName: "",
      selectedM: {},
      materialListDataInfo: {
        result: [],
      },
      activeName: 'my',
      lightIconKeys: ['lightBackgroundImage', 'validateCorrectIcon', 'validateFailIcon', 'pingCorrectIcon', 'pingFailIcon', 'callbackStatusIcon'],
      pageNum: 1,
      pageSize: 8
    };
  },
  computed: mapState(["curComponent", "componentData"]),
  watch: {
    materialName(v) {
      this.pageNum = 1; // 搜索时重置分页
      this.getMaterialsData({ file_name: v });
    },
    activeName(val, oldVal) {
      if (val !== oldVal) {
        this.selectedM = {};
        if (val === 'my') {
          const { pageNum, pageSize } = this.$refs.pagination.getPageInfo();
          this.pageNum = pageNum;
          this.pageSize = pageSize;
          this.getMaterialsData({}); // 切换回"我的素材"时重新加载
        }
      }
    }
  },
  mounted() {
    this.getMaterialsData({});
  },

  methods: {
    ...mapActions([
      'getMaterialTypeList'
    ]),
    commonSelected(item) {
      this.selectedM = item;
    },
    async getPicType() {
        try {
            this.$changeLoadingState(true);
            await this.getMaterialTypeList();
        } catch (error) {
            console.log(error);
        }
        this.$changeLoadingState(false);
    },
    handleCurrentPageChange(v) {
      this.pageNum = v;
      this.getMaterialsData({ page_num: v });
    },
    handleSizeChange(v) {
      this.pageNum = 1; // 切换每页数量时重置页码
      this.pageSize = v;
      this.getMaterialsData({ page_size: v });
    },
    onClose() {
      this.pageNum = 1;
      this.pageSize = 8;
      this.activeName = 'my';
      this.selectedM = {};
      this.dialogVisible = false;
    },
    getMaterialsData({ page_size, page_num, file_name }) {
      this.$request
        .queryMaterialsList({
          page_size: page_size || this.pageSize,
          page_num: page_num || this.pageNum,
          file_name
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.materialListDataInfo = res.data || {};
        });
    },
    quickEntrance() {
      const routeToOpen = this.$router.resolve('/privateResource/materials').href;
      window.open(routeToOpen, '_blank');
    },
    confirmToChange() {
      if (!this.selectedM.file_down_path) {
        this.$message.warning(this.$tt("请选择图片"));
        return;
      }
      const { file_down_path, file_real_name, file_md5, id, file_name } =
        this.selectedM;
      debugger;
      console.log('confirmToChange----', this.modalOperationKey);
      //如果画布外其他选图片
      if (this.modalOperationKey == "other") {
        this.confirm(this.selectedM.file_down_path, {
          file_down_path,
          file_real_name,
          file_md5,
          id,
          file_name,
        });
        return;
      }
      const all = this.componentData;
      // const index = this.componentData.findIndex(
      //   (i) => i.id == this.curComponent.id
      // );
      const ret = getCurComponentsInd(this.componentData, this.curComponent);
      let obj = {};
      if (this.modalOperationKey == "imageResource") {
        obj = {
          ...this.curComponent,
          propValue: {
            file_down_path,
            file_real_name,
            file_md5,
            id,
            file_name,
          },
        };
      } else if (this.modalOperationKey == "carouselPics") {
        this.setCarouselPics(this.selectedM);
        this.dialogVisible = false;
        this.selectedM = {};
        return;
      } else if (this.modalOperationKey === "musicControlIcon") {
        const style = { ...this.curComponent.style };
        setMusicControlIcon(style, {
          file_down_path,
          file_real_name,
          file_md5,
          id,
          file_name,
        });
        obj = {
          ...this.curComponent,
          style,
        };
      } else if (this.lightIconKeys.indexOf(this.modalOperationKey) !== -1) {
        // 状态灯相关的图标选择
        this.$emit('confirm', this.selectedM);
        this.dialogVisible = false;
        this.selectedM = {};
        return;
      } else {
        obj = {
          ...this.curComponent,
          style: {
            ...this.curComponent.style,
            [this.modalOperationKey == "backgroundImage" ||
            this.modalOperationKey == "backPicSrc"
              ? "backgroundInfo"
              : "pressBackgroundImageInfo"]: {
              file_down_path,
              file_real_name,
              file_md5,
              id,
              file_name,
            },
            ...(this.modalOperationKey == "backgroundImage"
              ? { backgroundColor: "transparent", backgroundType: "icon" }
              : {}),
            ...(this.modalOperationKey == "pressBackgroundImage"
              ? { pressBackgroundColor: "transparent", pressBackgroundType: "icon" }
              : {}),
            [this.modalOperationKey]: `url(${file_down_path})`,
          },
        };
      }
      // all.splice(index, 1, obj);
      if (ret.parentInd !== -1) {
        // 生态组件下的子组件
        all[ret.parentInd].propValue.splice(ret.index, 1, obj);
      } else {
        all.splice(ret.index, 1, obj);
      }
      this.$store.commit("setComponentData", all);
      this.$store.commit("setCurComponent", {
        component: {
          ...this.curComponent,
          ...obj,
        },
      });
      this.dialogVisible = false;
      this.selectedM = {};
    },
    switchDialogVisible(bol) {
      this.dialogVisible = bol;
      if (bol) {
        this.getPicType();
        // 打开时重置分页状态
        this.pageNum = 1;
        this.activeName = 'my';
        this.getMaterialsData({}); // 确保打开时加载第一页数据
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
.common-material-container {
    height: 300px;
  .el-pagination {
    margin-bottom: 0px;
  }
}
.materialListWrap {
  .el-dialog__header {
    // border: 1px solid #e6e6e6;
    display: none;
  }
  .el-dialog__body {
    padding: 20px !important;
    height: calc(100% - 70px); /* 调整高度 */
    overflow: hidden; /* 防止溢出 */
  }
  .el-tabs {
    height: 100%; /* 填满可用空间 */
    display: flex;
    flex-direction: column;

  .el-tabs__content {
    flex: 1; /* 填满剩余空间 */
    overflow: hidden; /* 防止嵌套滚动条 */
    position: relative;
  }
  .search {
    width: 200px;
    margin: 0 0 10px 10px;
  }
  .list {
    /* 图片列表容器 - 添加滚动 */
    .image-list-container {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start; /* 顶部对齐 */
      max-height: 350px; /* 固定高度 */
      padding-bottom: 10px;
    }
  }
    .el-pagination {
      margin-bottom: 0px;
    }
    .one {
      margin: 6px;
      background-color: #fff;
      width: 200px;
      height: 150px;
      cursor: pointer;
      border-radius: 6px;
      display: inline-block;
      overflow: hidden;
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
      border: 3px solid #f5f5f5;
      box-sizing: border-box;
      position: relative;
      .image {
        width: 100%;
        height: 114px;
      }
      .bottom {
        font-size: 16px;
        color: #607895;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 3px 8px;
        background-color: #ececec;
        width: 193px;
      }
    }
    .selected {
      border: 3px solid #fa9d07;
    }
    .el-icon-success {
      border-radius: 50%;
      position: absolute;
      top: 10px;
      left: 10px;
      color: #fa9d07;
      opacity: 1;
      width: 22px;
      align-items: center;
      justify-content: center;
      height: 22px;
      display: flex;
      font-size: 28px;
      background-color: #fff;
    }
  }
  .common-material-container {
    height: 100% !important; /* 填满父容器 */
    overflow: auto; /* 添加滚动 */
  }
}
</style>